const MVCObject = require("./../mvcobject").MVCObject;
const maps = require("../maps");

/**
 * @callback GoogleGeocoderErrorCallback
 * @description The function to call when a google geocoder error occurs.
 * @param {google.maps.GeocoderStatus} status the error status from the google geocoder.
 */

/**
 * @typedef {Object} GeocoderOptions
 * Represents the parameters for GeocoderSearchSource.
 * @property {Number} [maxResultsReturn] Maximum number of geocoding results return by the geocoder.
 * If google find more result then only the N first results will be returned.
 * @property [bounds] The bounding box of the viewport `GeocodingRequest parameters`.
 * @property [key] Your application's API key `GeocodingRequest parameters`.
 * @property [language] The language in which to return results `GeocodingRequest parameters`.
 * @property [region] The region code, specified as a ccTLD ("top-level domain") two-character value `GeocodingRequest parameters`.
 * @property {GoogleGeocoderErrorCallback} [errorCallback] The function to call when a geocoder error occurs. Google Maps only
 * @see {@link https://developers.google.com/maps/documentation/geocoding/requests-geocoding|Google Maps Geocoding}
 */

/**
 * GeocoderSearchSource
 * @extends woosmap.utils.MVCObject
 * @memberOf woosmap.location
 */
class GeocoderSearchSource extends MVCObject {
    /**
     * Constructs a new GecoderSearchSource
     * @constructor
     * @param {GeocoderOptions} [geocoderOptions] options for the geocoder
     *
     */
    constructor(geocoderOptions) {
        super();
        this.geocoderImpl = maps.geocoder.getGeocoderImplementation(this, geocoderOptions);

        /**
         * When google answer a geocoding requests with only one result, it sets this property.
         * If maxResultsReturn is set to one then google's answer always set this property.
         * This property is bindable
         * @see woosmap.utils.MVCObject#bindTo
         * @type {LatLngLiteral}
         */
        this.location = {};

        /**
         * When google answer a geocoding requests with more than one result, it sets this property.
         * This property is bindable
         * @see woosmap.utils.MVCObject#bindTo
         * @type {Array}
         */
        this.locationResults = [];

        /**
         * Observes his query to launch the geocoding.
         * @type {string}
         */
        this.query = null;
    }

    /**
     * Listens the changes of query.
     */
    query_changed() {
        const query = this.get("query");
        if (query) {
            this.search(query);
        }
    }

    /**
     * Use the google maps geocoder to geocode the query.
     * @param {String} query
     */
    search(query) {
        this.geocoderImpl.geocode(query);
    }
}

exports.GeocoderSearchSource = GeocoderSearchSource;
